export function generateEventDescription({
  title = "Acara Spesial",
  location = "lokasi pilihan",
  dateText = "tanggal acara",
}) {
  return `
<h3>Tentang Acara</h3>
<p>
<strong>${title}</strong> adalah acara yang dirancang untuk memberikan pengalaman yang
berkesan dan bermakna bagi setiap peserta. Acara ini menghadirkan suasana yang
nyaman, tertata dengan baik, dan dikemas secara profesional.
</p>

<h3>Waktu & Tempat</h3>
<p>
Acara ini akan diselenggarakan pada <strong>${dateText}</strong> dan bertempat di
<strong>${location}</strong>. Lokasi dipilih dengan mempertimbangkan kenyamanan,
aksesibilitas, dan pengalaman terbaik bagi para peserta.
</p>

<h3>Apa yang Akan Kamu Dapatkan</h3>
<ul>
  <li>Pengalaman acara yang tertata dan terorganisir</li>
  <li>Atmosfer yang nyaman dan profesional</li>
  <li>Kesempatan untuk terhubung dengan peserta lainnya</li>
  <li>Tiket resmi dengan sistem verifikasi</li>
</ul>

<h3>Informasi Tiket</h3>
<p>
Tiket tersedia dalam jumlah terbatas. Pastikan kamu melakukan pemesanan lebih awal
untuk mengamankan tempat dan menghindari kehabisan tiket.
</p>

<p>
Kami menantikan kehadiranmu dan berharap acara ini menjadi pengalaman yang
berkesan untuk kamu.
</p>
`;
}
